// extracted by mini-css-extract-plugin
export var card = "_so-0";
export var details = "_so-1";